var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.54af381e0c2f0d82d035508444850a43.svg#8';
                    var viewUrl = 'sprites.54af381e0c2f0d82d035508444850a43.svg#view-8';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 40 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };